module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tkMDUM/tc-custom/9781460342206.jpg?1728851674267",
      "alt": "This image is the cover for the book Crossfire Christmas, The Precinct"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crossfire Christmas, The Precinct\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An injured undercover agent must keep an innocent nurse from getting caught in the crossfire in the latest installment of The Precinct")]), _c('b'), _c('br'), _c('br'), _vm._v("With his life bleeding out from bullet wounds and a car crash, Charles Nash's best option is to kidnap the innocent nurse who stops to help him. At gunpoint, the jaded DEA undercover agent offers Teresa Rodriguez a desperate deal: if she keeps him alive long enough to find out who's blown his cover and set him up to die, she'll be home for Christmas. "), _c('br'), _c('br'), _vm._v("As the two go on the run from an unknown killer, the Good Samaritan gives Nash a bad case of unprofessional desire. He's drawn to the sexy little spitfire for her bravery, boldness and attitude. But how can he count on kissing her under the mistletoe when so many enemies are working to ensure they don't make it to the holidays?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA TODAY bestselling author Julie Miller writes breathtaking romantic suspense. She has sold millions of copies of her books worldwide, and has earned a National Readers Choice Award, two Daphne du Maurier prizes and an RT BookReviews Career Achievement Award. For a complete list of her books and more, go to "), _c('a', {
    attrs: {
      "href": "http://www.juliemiller.org"
    }
  }, [_vm._v("www.juliemiller.org")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0